import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
    SecurityContext,
    ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ProtocolIndependentPipe } from '../fi-pipes/protocol-independent.pipe';

@Component({
    selector: 'fi-tag2',
    template: `
        @if (imageUrl) {
          <div class="fi-tag-image" [style.background-image]="getBackgroundImage(imageUrl)"></div>
        }
        @if (!imageUrl && iconClass) {
          <div class="fi-tag-icon" [ngClass]="iconClass + ' fas fa-lg'"></div>
        }
        <div class="fi-tag-name">
          <span [innerHTML]="name"></span>
        </div>
        <div class="fi-tag-delete">
          <button mat-icon-button (click)="deleteTag.emit()">
            <mat-icon class="fas fa-times" [style.color]="color"></mat-icon>
          </button>
        </div>
        `,
    styleUrls: ['./fi-tag2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-tag2' },
    standalone: false,
})
export class FiTag2Component implements OnInit {
    @Input() name: string;
    @Input() imageUrl: string;
    @Input() iconClass: string;
    @HostBinding('style.background')
    @Input()
    color: string;

    @Output() deleteTag = new EventEmitter<void>();

    constructor(
        private sanitizer: DomSanitizer,
        private protocolIndependentPipe: ProtocolIndependentPipe,
    ) {}

    ngOnInit() {}

    getBackgroundImage(imageUrl: string) {
        return this.sanitizer.sanitize(
            SecurityContext.STYLE,
            'url("' + this.protocolIndependentPipe.transform(imageUrl) + '")',
        );
    }
}
